import { useIntl } from 'react-intl'

import { useFixedDraggable } from '@components/FixedDraggable'

import { useAuth } from '@modules/auth/contexts/AuthContext'

import { useAlert } from '@/hooks'

const QueueTopbarMenuButton = () => {
  const intl = useIntl()
  const alert = useAlert()
  const { setIsShow } = useFixedDraggable()
  const { currentUser } = useAuth()

  const openErrorModal = () => {
    const counterName = currentUser?.active_queue_counter?.name
    const clinicName = currentUser?.active_queue_counter?.queue?.clinic?.name

    alert.error({
      text: intl.formatMessage({ id: 'queue.counter.check_in_error' }, { counter: counterName, clinic: clinicName }),
    })
  }

  const setOpen = () => {
    const counterClinicId = currentUser?.active_queue_counter?.queue?.clinic_id
    if (currentUser?.active_queue_counter && currentUser?.active_clinic_id !== counterClinicId) {
      openErrorModal()
    } else {
      setIsShow((prev) => !prev)
    }
  }

  return (
    <button
      type="button"
      onClick={setOpen}
      className="btn btn-icon bg-body btn-color-gray-600 btn-active-color-primary h-40px"
    >
      <i className="fa-solid fa-layer-group fs-4" />
    </button>
  )
}

export { QueueTopbarMenuButton }
